export const BRAND = "#C1272D";
export const BRAND_HOVER = "#a81f23";

export function getModernUi(modern = false) {
  const card = modern
    ? {
        p: 6,
        bg: "white",
        borderRadius: "2xl",
        border: "1px solid",
        borderColor: "rgba(15, 23, 42, 0.06)",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
      }
    : {
        p: 6,
        borderWidth: "1px",
        borderRadius: "lg",
        boxShadow: "md",
        bg: "white",
      };

  const panel = modern
    ? {
        p: 5,
        bg: "white",
        borderRadius: "2xl",
        border: "1px solid",
        borderColor: "rgba(15, 23, 42, 0.06)",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)",
        overflow: "hidden",
      }
    : {
        bg: "white",
        boxShadow: "md",
        borderRadius: "lg",
      };

  const sectionHeading = modern
    ? { size: "md", mb: 4, color: "gray.700", fontWeight: "semibold" }
    : { size: "md", mb: 4, color: "#625752" };

  const subHeading = modern
    ? { size: "lg", mb: 6, color: "gray.700", fontWeight: "bold" }
    : { size: "lg", mb: 6, textAlign: "center", color: "#625752" };

  const input = modern
    ? {
        bg: "gray.50",
        borderColor: "gray.200",
        borderRadius: "xl",
        focusBorderColor: BRAND,
      }
    : {
        bg: "white",
        borderColor: "#625752",
        focusBorderColor: BRAND,
      };

  const primaryButton = {
    bg: BRAND,
    color: "white",
    _hover: { bg: BRAND_HOVER },
  };

  return {
    modern,
    card,
    panel,
    sectionHeading,
    subHeading,
    input,
    primaryButton,
  };
}